
import {
    Button,
    Box,
    Container,
    Flex,
    Heading,
    Image,
    Stack,
    Text,
    Alert,
    AlertIcon,
    AlertTitle,
    AlertDescription,
    Input,
    Card,
    CardHeader,
    CardBody,
    CardFooter,
    FormControl,
    FormLabel,
    FormHelperText,
    chakra, IconButton, HStack, useColorModeValue, Link, SimpleGrid, VStack
} from "@chakra-ui/react";

import {
    Table,
    Thead,
    Tbody,
    Tfoot,
    Tr,
    Th,
    Td,
    TableCaption,
    TableContainer,
} from '@chakra-ui/react'

import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css';
import 'swiper/css/pagination';
import 'swiper/css/navigation';

import Cookies from 'js-cookie';

// import required modules
import { Pagination,Keyboard, Mousewheel, Navigation } from 'swiper/modules';
import {ScreenContainer} from "../container/ScreenContainer";

// import './styles.css';

import {Header as Nav} from "../header/Header";
import {Footer} from "../footer/Footer";
import {Form, redirect, useNavigate} from "react-router-dom";
import React, {FormEvent, useEffect, useState} from "react";
import {EmailInputEvo} from "../forms/chakra/inputs/EmailInputEvo";
import {useEvoContext} from "../../context/evo.context";
import {FormControlEvo} from "../forms/chakra/FormControlEvo";
import PublicIssuesDataProvider from "../dataProviderEvo/public-issues-data-provider";
import IssuesDataProvider from "../dataProviderEvo/issues-data-provider";
import {ReadIssueWithImageLink} from "../links/ReadIssueWithImageLink";
import {ROUTE_ISSUE_LIST, ROUTE_MAIN, ROUTE_PASSWORD_CHANGE, ROUTE_PASSWORD_RESET} from "../../App";
import UserBookmarksDataProvider from "../dataProviderEvo/user-bookmarks-data-provider";

function getEmptyFormData(){
    return {
        email: '',
        password: '',
        name: '',
        ico: '',
        street: '',
        city: '',
        zipCode: '',
    };
}


export default function Profile() {

    const navigate = useNavigate();
    const {isLoggedIn, setIsLoggedIn, userData, hasSubscriptionActive} = useEvoContext();
    const [showNoSubsMessage, setShowNoSubsMessage] = useState(false);

    // if(!isLoggedIn){
    //     navigate('/');
    // }
    //
    // useEffect(() => {
    //     if(!isLoggedIn){
    //         navigate(ROUTE_MAIN);
    //     }
    //  }, [isLoggedIn]);


    // const [formData, setFormData] = useState(getEmptyFormData());
    //
    // useEffect(() => {
    //
    //     const keys = Object.keys(userData); // ['id', 'name', 'email', 'age', 'isActive', 'address']
    //     const values = Object.values(userData);
    //
    //     if(keys.length > 0){
    //
    //         {keys.map((value, index) => (
    //             setFormData((prevData) => ({
    //                 ...prevData,
    //                 [keys[index]]: values[index],
    //             }))
    //         ))}
    //     } else {
    //         setFormData(getEmptyFormData());
    //     }
    //
    // }, [userData]);

    // Handle form input changes
    // const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    //     const { name, value } = e.target;
    //     setFormData((prevData) => ({
    //         ...prevData,
    //         [name]: value,
    //     }));
    // };

    // Handle form submission
    const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
        e.preventDefault(); // Prevent default form submission

        // console.log(formData);
        //
        // try {
        //     // Here, you could send the form data to the server
        //     const response = await fetch('/your-api-endpoint', {
        //         method: 'POST',
        //         headers: { 'Content-Type': 'application/json' },
        //         body: JSON.stringify(formData),
        //     });
        //
        //     const result = await response.json();
        //     console.log(result); // Process server response here
        //
        // } catch (error) {
        //     console.error('Error submitting form:', error);
        // }
    };


    const definedUserData = userData as { email?: string; name?: string; street?: string; city?: string; zipCode?: string };


    return (
        <Box bg={useColorModeValue('#f9f9f9', '#1a202c')}>
        <Nav />
            <ScreenContainer>

                <Stack direction={{ base: 'column', md: 'column' }}>
                    <Flex pt={8} flex={1} align={'center'} justify={'center'}>
                        <chakra.h1 textAlign={'center'} fontSize={'4xl'} pb={10} fontWeight={'bold'}>
                            {definedUserData.name}
                        </chakra.h1>
                    </Flex>

                </Stack>
                <>
                {!hasSubscriptionActive && (<Flex gap="4" mb={4} direction="column">
                    <Alert
                        status='warning'
                        variant='subtle'
                        flexDirection='column'
                        alignItems='center'
                        justifyContent='center'
                        textAlign='start'
                    >

                        <Flex alignItems='center' direction="row">
                            <AlertIcon />
                            <Flex direction="column">
                            <AlertTitle>{"Nemáte aktivní předplatné"}</AlertTitle>
                            <AlertDescription>
                                <Text pr={"3"} as={'span'}>{"Pořiďte si jej a získejte nejen přístup k nejnovějším článkům, ale také k bohatému archivu minulých vydání. Vraťte se ke svým oblíbeným textům kdykoli a nenechte si ujít další inspiraci!"}</Text>
                                <Link color="blue.500"
                                      textDecoration="underline"
                                      size="sm" colorScheme='blue' as={"a"} href={"predplatne"}>
                                    {"Zakoupit předplatné"}
                                </Link>
                            </AlertDescription>
                            </Flex>
                        </Flex>
                    </Alert>
                </Flex>)}
                </>
                <Box  bg={"white"} padding={"10"} boxShadow={"md"} borderRadius={10}>
                    <VStack align="start" spacing={4}>
                        <Box flexDirection={"row"}>
                            <Text fontWeight="bold">{"E-mail"}:</Text>
                            <Text>{definedUserData.email}</Text>
                        </Box>

                        <Box flexDirection={"row"}>
                            <Text fontWeight="bold">{"Jméno a příjmení"}:</Text>
                            <Text>{definedUserData.name}</Text>
                        </Box>

                        {definedUserData.street && (<Box flexDirection={"row"}>
                            <Text fontWeight="bold">{"Ulice"}:</Text>
                            <Text>{definedUserData.street}</Text>
                        </Box>)}

                        {definedUserData.city && (<Box flexDirection={"row"}>
                            <Text fontWeight="bold">{"Město"}:</Text>
                            <Text>{definedUserData.city}</Text>
                        </Box>)}

                        {definedUserData.zipCode && (<Box flexDirection={"row"}>
                            <Text fontWeight="bold">{"PSČ"}:</Text>
                            <Text>{definedUserData.zipCode}</Text>
                        </Box>)}

                    </VStack>
                </Box>
                <MenuList />
                <ReleasesCarousel />
                <BookmarksCarousel />
                <SubscriptionsList userData={userData}/>
            </ScreenContainer>
            <Footer />
        </Box>
    )
}


const releases = [
    { id: 1, image: '/cover1.png', label: 'casopis' },
    { id: 2, image: '/cover2.png', label: 'casopis' },
    { id: 3, image: '/cover3.png', label: 'casopis' },
    { id: 4, image: '/cover4.png', label: 'casopis' },
    { id: 5, image: '/cover1.png', label: 'casopis' },
    { id: 6, image: '/cover2.png', label: 'casopis' },
    { id: 7, image: '/cover3.png', label: 'casopis' },
    { id: 8, image: '/cover4.png', label: 'casopis' },
]


const MenuList = () => {

    return (
        <VStack my={4} alignItems={"start"}>
            <Button as="a" href={ROUTE_PASSWORD_CHANGE} colorScheme="pink">
                {"Změnit heslo"}
            </Button>
        </VStack>
    );
}

interface Subscription {
    id_subscription: string;
    user: string;
    type?: {
        code: string;
        value: string;
        order: string;
        length_months: string;
        actual: string;
        subscription_type_price?: {
            price?: {
                value: string;
                currency?: {
                    value: string;
                };
            };
        };
    }; // Remove "| string" if this is always an object
    date_start: string;
    date_end: string;
    price?: {
        id_subscription_price: string;
        subscription: string;
        date: string;
        subscription_type_price?: {
            price?: {
                value: string;
                currency?: {
                    value: string;
                };
            };
        };
    };
    basket? : {
        invoice: string
    }
}
interface UserData {
    subscriptions?: Subscription[];
}


const SubscriptionsList: React.FC<{ userData: UserData }> = ({ userData }, setShowNoSubsMessage) => {
    const subscriptions = userData?.subscriptions ?? [];

    if (subscriptions.length === 0) {
        return (
            <>
            <chakra.h2 textAlign={'start'} fontSize={'4xl'} py={10} fontWeight={'bold'}>
                Moje platby
            </chakra.h2>
            <Box bg={"white"} padding={"10"} boxShadow={"md"} borderRadius={10}>
                <Text textAlign="center" mt="2%" color="gray.500">
                    K dispozici nemáte žádné platby.
                </Text>
            </Box>
            </>
        );
    }

    return (
        <>
       <chakra.h2 textAlign={'start'} fontSize={'4xl'} py={10} fontWeight={'bold'}>
                Moje platby
       </chakra.h2>
        <Box bg={"white"} padding={"10"} boxShadow={"md"} borderRadius={10}>
            <TableContainer mt="2%">
                <Table variant="simple">
                    <Thead>
                        <Tr>
                            <Th>Datum platby</Th>
                            <Th>Členství do</Th>
                            <Th>Název</Th>
                            <Th>Cena</Th>
                        </Tr>
                    </Thead>
                    <Tbody>
                        {subscriptions.map((subscription, index) => {
                            const paymentDate = subscription.price?.date || "-";
                            const membershipEndDate = subscription.date_end || "-";
                            const subscriptionName =
                                typeof subscription.type === "object"
                                    ? subscription.type.value
                                    : subscription.type || "-";
                            const priceValue =
                                subscription.type?.subscription_type_price?.price?.value || "-";
                            const currency =
                                subscription.type?.subscription_type_price?.price?.currency?.value ||
                                "";
                            const invoice =
                                subscription.basket?.invoice ||
                                "";

                            return (
                                <Tr key={index}>
                                    <Td>{paymentDate}</Td>
                                    <Td>{membershipEndDate}</Td>
                                    <Td>{subscriptionName}</Td>
                                    <Td textAlign={"center"}>
                                        {priceValue !== "-" ? `${priceValue} ${currency}` : "-"}
                                    </Td>
                                    {invoice && (<Td textAlign={"center"}>
                                        <Link fontWeight={"semibold"} fontSize="md" href={invoice} color="blue.500">
                                            {"Faktura"}
                                        </Link>
                                    </Td>)}
                                </Tr>
                            );
                        })}
                    </Tbody>
                </Table>
            </TableContainer>
        </Box>
            </>
    );
};

interface Issue {
    id_issue: string;
    title: string;
    header: string | null;
    year: string;
    date_publish: string;
    [key: string]: any; // For additional fields
}

const ReleasesCarousel = () => {

    const [issueData, setIssueData] = useState<{ [key: string]: any }>({});
    const {authToken} = useEvoContext();

    useEffect(() => {

        if(authToken && Object.keys(issueData).length  == 0) {
            let dp = new IssuesDataProvider();

            let headers = {
                // "Auth-login-name": formData.email,
                // "Auth-login-password-b64": btoa(formData.password),
                "Auth-token": authToken
            }

            dp.getData({}, headers).then((res) => {

                if (res && res.status === 'OK') {
                    const reverseDataByDate = (data: Record<string, Issue>): Array<{ key: string } & Issue> => {
                        const reversedEntries = Object.entries(data)
                            .sort(([, a], [, b]) => new Date(b.date_publish).getTime() - new Date(a.date_publish).getTime());

                        return reversedEntries.map(([key, value]) => ({ key, ...value }));
                    };

                    const reversedData = reverseDataByDate(res.data);
                    setIssueData(reversedData);

                }
            });
        }

    }, [authToken]);

    return (
        <>
    { Object.keys(issueData).length > 0 && (
    <Stack direction={{ base: 'column', md: 'column' }}>
        <chakra.h2 textAlign={'start'} fontSize={'4xl'} py={10} fontWeight={'bold'}>
            Moje časopisy
        </chakra.h2>


        {/*return (*/}
        {/*    <Carousel images={images} />*/}
        {/*);*/}
        <Box bg={"white"} padding={"10"} boxShadow={"md"} borderRadius={10}>
        <Stack   direction={{ base: 'row', md: 'row' }}>

            <Swiper   slidesPerView={4}
                      spaceBetween={30}
                      // pagination={{
                      //     clickable: true,
                      // }}
                      navigation={true}
                      breakpoints={{
                          0: {
                              slidesPerView: 1,
                              spaceBetween: 20,
                          },
                          480: {
                              slidesPerView: 1,
                              spaceBetween: 20,
                          },
                          640: {
                              slidesPerView: 2,
                              spaceBetween: 20,
                          },
                          768: {
                              slidesPerView: 3,
                              spaceBetween: 40,
                          },
                          1024: {
                              slidesPerView: 4,
                              spaceBetween: 50,
                          },
                      }}
                      modules={[Navigation, Pagination, Mousewheel, Keyboard]}
                      className="mySwiper">
                {Object.entries(issueData).slice(0, 4).map(([index, value]) => (
                    <SwiperSlide key={index}>
                        <Card maxW='sm' mx={2} border="none" key={index} >
                            <ReadIssueWithImageLink privateIssue={true} issue_id={value.id_issue}  imageSrc={value.image.image_url} borderRadius='lg'  style={{
                                maxWidth: "100%", // Fixed width
                                height: "auto", // Fixed height
                                objectFit: "cover",
                            }} />
                            {/*<a href={"precist"}><Image*/}
                            {/*    src={value.image}*/}
                            {/*    alt={value.title}*/}
                            {/*    borderRadius='lg'*/}
                            {/*/></a>*/}
                        </Card>

                        {/*<Image src={value.image} alt={`Slide ${index + 1}`} objectFit="cover" />*/}
                    </SwiperSlide>
                ))}
            </Swiper>
        </Stack>
        </Box>
        {Object.keys(issueData).length > 4 && (<Stack mt={10} justifyContent={"center"} direction={{ base: 'column', md: 'row' }} spacing={4}>
            <Button colorScheme='pink' variant='outline'>
                <a href={ROUTE_MAIN + ROUTE_ISSUE_LIST}>Všechna vydání</a>
            </Button>
        </Stack>)}
    </Stack>)
        }
    </>)
}

const BookmarksCarousel = () => {

    const [bookmarks, setBookmarks] = useState<{ [key: string]: any }>({});
    const { authToken, isLoggedIn, userId } = useEvoContext();

    const filterUniqueIssues = (data: Record<string, any>) => {
        const dataArray = Object.values(data);
        const uniqueIssuesMap = new Map();

        dataArray.forEach((item) => {
            const issueId = item.id_issue.id_issue;
            if (!uniqueIssuesMap.has(issueId)) {
                uniqueIssuesMap.set(issueId, item);
            }
        });

        return Object.fromEntries(
            Array.from(uniqueIssuesMap.entries()).map(([key, value]) => [value.id_user_issue_bookmark, value])
        );
    };

    useEffect(() => {
        if (isLoggedIn && authToken && Object.keys(bookmarks).length === 0) {
            const dp = new UserBookmarksDataProvider();
            dp.getData(userId, authToken).then((res) => {
                if (res && res.status === 'OK') {
                    setBookmarks(filterUniqueIssues(res.data));
                }
            });
        }
    }, [authToken, isLoggedIn, userId, bookmarks]);

    const generateSlides = () => {
        const bookmarkEntries = Object.entries(bookmarks).slice(0, 4);
        const slides = bookmarkEntries.map(([id, bookmark]) => (
            <SwiperSlide key={id}>
                <Card maxW="sm" mx={2} border="none">
                    <ReadIssueWithImageLink
                        privateIssue={isLoggedIn}
                        issue_id={bookmark.id_issue.id_issue}
                        imageSrc={bookmark.id_issue.image.image_url}
                        borderRadius="lg"
                        style={{
                            maxWidth: "100%",
                            height: "auto",
                            objectFit: "cover",
                        }}
                    />
                </Card>
            </SwiperSlide>
        ));

        // Add invisible placeholders if there are fewer than 4 bookmarks
        for (let i = slides.length; i < 4; i++) {
            slides.push(
                <SwiperSlide key={`placeholder-${i}`} style={{ visibility: 'hidden' }}>
                    <Card maxW="sm" mx={2} border="none">
                        <Box
                            height="200px"
                            display="flex"
                            alignItems="center"
                            justifyContent="center"
                            bg="gray.200"
                            borderRadius="lg"
                        >
                            Placeholder
                        </Box>
                    </Card>
                </SwiperSlide>
            );
        }

        return slides;
    };

    return (
        <>
            {Object.keys(bookmarks).length > 0 && (
                <Stack direction={{ base: 'column', md: 'column' }}>
                    <chakra.h2 textAlign={'start'} fontSize={'4xl'} py={10} fontWeight={'bold'}>
                        Moje záložky
                    </chakra.h2>
                    <Box bg={"white"} padding={"10"} boxShadow={"md"} borderRadius={10}>
                        <Stack direction={{ base: 'row', md: 'row' }}>
                            <Swiper
                                slidesPerView={4}
                                spaceBetween={30}
                                pagination={{ clickable: true }}
                                navigation={true}
                                breakpoints={{
                                    0: { slidesPerView: 1, spaceBetween: 20 },
                                    480: { slidesPerView: 1, spaceBetween: 20 },
                                    640: { slidesPerView: 2, spaceBetween: 20 },
                                    768: { slidesPerView: 3, spaceBetween: 40 },
                                    1024: { slidesPerView: 4, spaceBetween: 50 },
                                }}
                                modules={[Navigation, Pagination, Mousewheel, Keyboard]}
                                className="mySwiper"
                            >
                                {generateSlides()}
                            </Swiper>
                        </Stack>
                    </Box>
                </Stack>
            )}
        </>
    );
};






